const getBaseUrl = () => {
    // console.log("process.env.NODE_ENV config",process.env.NODE_ENV);
    switch (process.env.NODE_ENV) {
      case "production":
        return process.env.REACT_APP_PRODUCTION_URL;
      case "test":
        return process.env.REACT_APP_TEST_URL;
      default:
        return process.env.REACT_APP_DEVELOPMENT_URL;
    }
  };
  
  export const BASE_URL = getBaseUrl();
   